export const changeAccessibilityType = type => ({
  type: 'change_accessibility_type',
  payload: type
})
